import { useToggle } from "client/hooks/utils/useToggle";
import { useDispatch } from "react-redux";
import { deleteAllImages } from "store/features/bulkResize/actions";

export const useDeleteAll = () => {
    const { isOpen, open, onClose: close } = useToggle();
    const dispatch = useDispatch();

    const handleDeleteAll = () => {
        dispatch(deleteAllImages());
        close();
    };

    return {
        isOpen,
        open,
        close,
        handleDeleteAll,
    };
};
